var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCircleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0013 0.666626C6.6413 0.666626 0.667969 6.63996 0.667969 14C0.667969 21.36 6.6413 27.3333 14.0013 27.3333C21.3613 27.3333 27.3346 21.36 27.3346 14C27.3346 6.63996 21.3613 0.666626 14.0013 0.666626ZM10.388 19.72L5.6013 14.9333C5.0813 14.4133 5.0813 13.5733 5.6013 13.0533C6.1213 12.5333 6.9613 12.5333 7.4813 13.0533L11.3346 16.8933L20.508 7.71996C21.028 7.19996 21.868 7.19996 22.388 7.71996C22.908 8.23996 22.908 9.07996 22.388 9.59996L12.268 19.72C11.7613 20.24 10.908 20.24 10.388 19.72Z",
    fill: "#5BDD87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleCheck);
export default __webpack_public_path__ + "static/media/green-circle-check.5a16a8d1e1d3ddc82f7813d237f20703.svg";
export { ForwardRef as ReactComponent };